import { AirdropChecker } from '@/components/molecules/AirdropChecker/AirdropChecker'
import LootboxPurchase from '@/components/molecules/LootboxPurchaseModal/LootboxPurchaseModal'
import { LootboxMarketModal } from '@/components/molecules/LootboxMarketModal/LootboxMarketModal'
// import { LootboxMarketOrder } from '@/components/molecules/LootboxMarketOrderModal/LootboxMarketOrderModal'
import { LootboxRewardModal } from '@/components/templates/Lootbox/organisms/LootboxRewardModal/RewardModal'
import { LootboxUsersOrdersModal } from '@/components/templates/Lootbox/organisms/UserOrdersModal/UserOrdersModal'

export const LootboxModals = {
  LootboxPurchase: {
    component: LootboxPurchase,
  },
  LootboxRewardModal: {
    component: LootboxRewardModal,
  },
  LootboxMarketModal: {
    component: LootboxMarketModal,
  },
  // LootboxMarketOrder: {
  //   component: LootboxMarketOrder,
  // },
  LootboxUsersOrdersModal: {
    component: LootboxUsersOrdersModal,
  },
  AirdropChecker: {
    component: AirdropChecker,
  },
}
